import { render, staticRenderFns } from "./Skimovie.vue?vue&type=template&id=39887545&"
import script from "./Skimovie.vue?vue&type=script&lang=js&"
export * from "./Skimovie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports